<div id="shared-modal-container" class="modal">
  <div id="shared-modal-icon-wrapper" class="modal-closeIcon">
    <app-icon
      id="shared-modal-close-icon"
      *ngIf="closeIconRequired"
      name="close"
      (click)="onCloseModal()"
      size="1.4em"
      color="primary"
    ></app-icon>
  </div>
  <div id="shared-modal-title-wrapper" *ngIf="modalTitle" class="modal-title">
    <app-text id="shared-modal-title" [textStyleType]="'headline2'">{{
      modalTitle
    }}</app-text>
  </div>
  <div id="shared-modal-component-wrapper" mat-dialog-content *ngIf="data.component">
    <ng-container
      id="shared-modal-component"
      *ngComponentOutlet="data.component"
    ></ng-container>
  </div>
  <div id="shared-modal-template-wrapper" mat-dialog-content *ngIf="data.template">
    <ng-container
      id="shared-modal-template"
      *ngTemplateOutlet="data.template"
    ></ng-container>
  </div>
</div>
